export const fixUrl = url => {
  try {
    new URL(url);
  } catch (e) {
    if (new RegExp('^(/)?archives/').test(url)) {
      return "https://static.wixstatic.com" + url;
    }
  }
  return url;
};
//# sourceMappingURL=fix-url.js.map